/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Joyride from 'react-joyride'
import { useHistory } from 'react-router'
import IdCardScreen from '../components/idcardscreen'
import { Box, VStack, Image, Flex } from '@chakra-ui/react'
import defaultProfilePic from '../assets/images/profile.png'
import { useAuthContext } from '../context/auth.context'
import { loadAwsFile } from '../utils/aws.util'
import UserDetails from '../components/userdetails'
import { useOrganizationContext } from '../context/organization.context'
import { useLanguageContext } from '../context/locale.context'
import ButtonCTA from '../components/globalComponents/button'
import './idcard.page.css'
import { useGetIdcardDetails } from '../hooks/asset.hooks'
import SVGIcon from '../assets/svgIcons'
import { AUTH_SESSION_JOY_CHECK } from '../utils/constant'

const IdCardPage = () => {
	const {
		state: { authData },
	} = useAuthContext()

	const {
		state: { locale },
	} = useLanguageContext()

	const {
		state: { orgsColor },
	} = useOrganizationContext()

	const [profileImageData, setProfileImageData] = useState(null)
	const [orgLogo, setOrgLogo] = useState(null)
	const [idCardDetails, setIdCardDetails] = useState({})
	const { mutate: getIdcard, isLoading } = useGetIdcardDetails()
	const [joyrideVisible, setJoyrideVisible] = useState(false)
	const [joyrideShown, setJoyrideShown] = useState(false)
	const history = useHistory()

	useEffect(() => {
		setTimeout(() => {
			if (!!authData.asset_image_path) {
				loadAwsFile(authData.asset_image_path, d => {
					let data = 'data:' + d.type + ';base64,' + d.data
					setProfileImageData(data)
				})
			}
		}, 1000)
		setTimeout(() => {
			if (!!authData.organization_image_path) {
				loadAwsFile(authData.organization_image_path, d => {
					let data = 'data:' + d.type + ';base64,' + d.data
					setOrgLogo(data)
				})
			}
		}, 1000)
		loadIdCardDetails()
	}, [])

	const loadIdCardDetails = () => {
		if (authData?.operating_asset_id && authData?.organization_id) {
			setTimeout(() => {
				getIdcard(
					{
						target_asset_id: authData.operating_asset_id,
						organization_id: authData.organization_id,
					},
					{
						onSuccess: async res => {
							if (res) {
								const {
									data: { status, response },
								} = res

								if (status === 200) {
									setIdCardDetails(response[0])
									loadAwsFile(response[0]?.activity_inline_data?.employee_profile_picture, d => {
										let data = 'data:' + d.type + ';base64,' + d.data
										setProfileImageData(data)
									})
								}
							}
						},
					}
				)
			}, 1000)
		}
	}

	useEffect(() => {
		setTimeout(() => {
			if (!!authData.asset_image_path) {
				loadAwsFile(authData.asset_image_path, d => {
					let data = 'data:' + d.type + ';base64,' + d.data
					setProfileImageData(data)
				})
			}
		}, 1000)
	}, [authData.asset_image_path])

	useEffect(() => {
		setTimeout(() => {
			if (!!authData.organization_image_path) {
				loadAwsFile(authData.organization_image_path, d => {
					let data = 'data:' + d.type + ';base64,' + d.data
					setOrgLogo(data)
				})
			}
		}, 1000)
	}, [authData.organization_image_path, orgLogo])

	useEffect(() => {
		if (authData?.operating_asset_id && authData?.organization_id) {
			setTimeout(() => {
				getIdcard(
					{
						target_asset_id: authData.operating_asset_id,
						organization_id: authData.organization_id,
					},
					{
						onSuccess: async res => {
							if (res) {
								const {
									data: { status, response },
								} = res

								if (status === 200) {
									setIdCardDetails(response[0])
								}
							}
						},
					}
				)
			}, 1000)
		}
	}, [authData.operating_asset_id, authData.organization_id])

	const steps = [
		{
			target: '#zero-touch',
			content: `${locale['Click here to go to the Workspace']}`,
			disableBeacon: true,
		},
		{
			target: '#share-contact',
			content: `${locale['Click here to share your business card']}`,
		},
		{
			target: '#start-stop-shift',
			content: `${locale['Click here to set your shift hours']}`,
		},
		{
			target: '#apply-leave',
			content: `${locale['Click here to apply leaves']}`,
		},
	]

	const menuButtons = () => {
		return (
			<>
				<Box ml='47px' mt='47px'>
					{/* <Image
						src={greneIcon}
						maxW='2.25rem'
						mr='4px'
						display='inline-block'
					/> */}
					<Box mr='4px' display='inline-block'>
						<SVGIcon
							iconName='GreenLogoLineSvg'
							svgProps={{
								width: '36',
								height: '10',
								viewBox: '0 0 36 10',
							}}
							// pathProps={{ fill: '#009B76' }}
						/>
					</Box>{' '}
					{locale['What do you want to do']}
				</Box>
				<VStack alignItems='self-end' mr='48px' mt='36px'>
					<ButtonCTA
						variant='idcardButton'
						id='zero-touch'
						onClick={() => history.push('/requests')}
					>
						{locale['Workspace']}
					</ButtonCTA>

					<ButtonCTA
						variant='idcardButton'
						onClick={() => history.push('/sharecontact')}
						id='share-contact'
					>
						{locale['Share Business card']}
					</ButtonCTA>

					{/* <ButtonCTA variant='idcardButton'>{locale['Linked IDs']}</ButtonCTA>
					<ButtonCTA variant='idcardButton' id='start-stop-shift'>
						{locale['Start']}/{locale['Stop Shifts']}
					</ButtonCTA> */}
					{/* <ButtonCTA variant='idcardButton' id='apply-leave'>
						{locale['Apply Leave']}
					</ButtonCTA> */}
				</VStack>
			</>
		)
	}
	useEffect(() => {
		if (!sessionStorage.getItem(AUTH_SESSION_JOY_CHECK)) {
			setJoyrideVisible(true)
		}
	}, [])
	const handleJoyrideClose = data => {
		const { action, index, status, type } = data

		if (action === 'close' || action === 'reset' || action === 'stop') {
			setJoyrideVisible(false)
			sessionStorage.setItem(AUTH_SESSION_JOY_CHECK, true)
		}
	}

	return (
		<>
			<Joyride
				continuous={true}
				hideCloseButton={false}
				run={joyrideVisible}
				scrollToFirstStep
				showSkipButton
				steps={steps}
				locale={{
					next: (
						<Flex aria-label='next' gap='0.5em'>
							{locale['Next']}
							{/* <Image src={chevronRight} /> */}
							<SVGIcon
								iconName='WhiteRightArrowSvg'
								svgProps={{
									width: '9',
									height: '16',
									viewBox: '0 0 9 16',
								}}
								// pathProps={{ fill: '#009B76' }}
							/>
						</Flex>
					),
					back: (
						<Flex aria-label='back' gap='0.5em'>
							{/* <Image src={chevronLeft} /> */}
							<SVGIcon
								iconName='WhiteLeftArrowSvg'
								svgProps={{
									width: '9',
									height: '16',
									viewBox: '0 0 9 16',
								}}
								// pathProps={{ fill: '#009B76' }}
							/>
							{locale['Back']}
						</Flex>
					),
					last: (
						<Flex aria-label='finish' gap='0.5em'>
							{locale['Finish']}
							{/* <Image src={chevronRight} /> */}
							<SVGIcon
								iconName='WhiteRightArrowSvg'
								svgProps={{
									width: '9',
									height: '16',
									viewBox: '0 0 9 16',
								}}
								// pathProps={{ fill: '#009B76' }}
							/>
						</Flex>
					),
				}}
				styles={{
					beacon: {
						display: 'none',
					},
					overlay: {
						backgroundColor: 'rgba(0, 0, 0, 0.8)',
					},
					buttonNext: {
						backgroundColor: 'transparent',
						color: 'white',
					},
					buttonClose: {
						backgroundColor: 'transparent',
						color: 'white',
						border: '1px solid white',
						borderRadius: '1000px',
						padding: '0.5em',
					},
					buttonBack: {
						backgroundColor: 'transparent',
						color: 'white',
						marginLeft: '0.5em',
						marginRight: '20%',
					},
					tooltip: {
						backgroundColor: 'transparent',
						color: 'white',
					},
					floater: {
						arrow: {
							color: 'red',
						},
					},
				}}
				callback={handleJoyrideClose}
			/>
			<UserDetails
				idCardDetails={idCardDetails}
				profileImageData={profileImageData}
				defaultProfilePic={defaultProfilePic}
				orgLogo={orgLogo}
				orgColor={orgsColor[authData.organization_id]}
				toBeDisplayed={menuButtons()}
				loadIdCardDetails={loadIdCardDetails}
				
			/>
		</>
	)
}

export default IdCardPage
